export enum TravelExpensesStateEnum {
    NOT_LEGALIZED = 'notLegalized',
    READY_TO_VALIDATE = 'readyToValidate',
    PARTIALLY_LEGALIZED = 'partiallyLegalized',
    LEGALIZED = 'legalized',
}

export enum TravelExpensesStateDict {
    'notLegalized' = 'Sin legalizar',
    'readyToValidate' = 'Listo para validar',
    'partiallyLegalized' = 'Parcialmente legalizado',
    'legalized' = 'Legalizado',
}

